import { http } from "@/src/service/flow/FlowFrontendService";
import type { LeadBody } from "@/src/type/contact";

async function postContactForm(body: LeadBody) {
  return await http<any>("POST", "/v1/contact", undefined, body);
}

export default { postContactForm };
